import { useFeaturedVenues } from '../hooks/useFeaturedVenues';
import type { Direction } from '../lib/types';
import SEO from '../components/SEO';
import NavBarLight from '../components/home/v2/NavBarLight';
import HeroClearance from '../components/home/v2/HeroClearance';
import SearchPanel from '../components/home/v2/SearchPanel';
import VenueScoreCards from '../components/home/v2/VenueScoreCards';
import WhyDirectionMatters from '../components/home/v2/WhyDirectionMatters';
import TrustedBy from '../components/home/v2/TrustedBy';
import FooterLight from '../components/home/v2/FooterLight';

export default function HomePage() {
  const { venues } = useFeaturedVenues(4);

  // Feed the hero compass with the best-scored venue's real per-direction scores.
  // Use the first venue that has a real score in all four directions, so the
  // hero compass never shows a "0 / Fair" placeholder node.
  const heroVenue = venues.find((v) =>
    (['N', 'E', 'S', 'W'] as Direction[]).every((d) => v.scores[d].score > 0),
  );
  const heroScores = heroVenue
    ? ({
        N: { direction: 'N' as Direction, score: heroVenue.scores.N.score, label: heroVenue.scores.N.label },
        E: { direction: 'E' as Direction, score: heroVenue.scores.E.score, label: heroVenue.scores.E.label },
        S: { direction: 'S' as Direction, score: heroVenue.scores.S.score, label: heroVenue.scores.S.label },
        W: { direction: 'W' as Direction, score: heroVenue.scores.W.score, label: heroVenue.scores.W.label },
      })
    : undefined;

  return (
    <div className="bg-white min-h-screen">
      <SEO
        title="ParkingRank — Park smarter. Leave faster."
        description="We score every garage exit near major venues by direction so you can choose the fastest way out. 4,700+ garages, 350+ venues, 196 cities."
        canonical="/"
      />
      <NavBarLight />
      <HeroClearance scores={heroScores} />
      <SearchPanel />
      <VenueScoreCards />
      <WhyDirectionMatters />
      <TrustedBy />
      <FooterLight />
    </div>
  );
}
